/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { messageResponseSchema } from "../messageResponseSchema.ts";
import { userInfoSchema } from "../userInfoSchema.ts";
import { z } from "zod";

export const inviteUserToOrganizationPathParamsSchema = z.object({
      "id": z.string().describe("ID unique de l'organisation.")
      })

export const inviteUserToOrganizationHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description Réponse contenant un message simple
 */
export const inviteUserToOrganization200Schema = z.lazy(() => messageResponseSchema).describe("Réponse contenant un message simple")

/**
 * @description Réponse d\'erreur standard
 */
export const inviteUserToOrganization500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const inviteUserToOrganizationMutationRequestSchema = z.lazy(() => userInfoSchema)

export const inviteUserToOrganizationMutationResponseSchema = z.lazy(() => inviteUserToOrganization200Schema)